<template>
  <el-dialog class="candidate-superiors-doalog" title="选择候选人" :visible.sync="data.visible" width="510px" center :close-on-click-modal="false" append-to-body>
    <div class="content">
      <div class="select-content">
        <div class="left">
          <div class="tabs">
            <div class="tab-title"> 我的上级 </div>
            <div class="tab-content">
              <div class="dep-content">
                <el-tree ref="tree" :data="departments" :props="defaultProps" :indent="12" :expand-on-click-node="false" node-key="id">
                  <span class="custom-dep-tree" slot-scope="{ node, data }">
                    <span @click.stop="expandNode(node)"></span>

                    <span :class="['node-name', getShowCheck(data) && 'checked-name']" :style="{width: getWidth(node)}" :title="node.label" @click="nodeClick(data)">{{ node.label }}</span>
                    <span v-show="getShowCheck(data)" class="el-icon-check"></span>
                  </span>
                </el-tree>
              </div>
            </div>
          </div>
        </div>
        <!-- 选择区域 -->
        <div class="right">
          <div class="title">已选择</div>
          <div class="selected-content" ref="selectedContent">
            <div class="select-item" v-for="item in selectedData" :key="item.id">
              <div class="select-item-content">
                <span class="group-name" :title="item.name">{{ item.name }}</span>
                <span class="el-icon-error" @click.stop="delSelected(item)"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="timing-button-primary" type="primary" @click="saveData">确 定</el-button>
      <el-button class="timing-button-default" @click="data.visible = false">取 消</el-button>
  </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'candidate-superiors',
  props: ['data'],
  data () {
    return {
      departments: [],
      selectedData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  async created () {
    this.selectedData = []
    // 需要当前登录人的直属上级
    this.departments = this.data.allPeople
    if (this.data.data && this.data.data.length > 0) {
      this.$_.cloneDeep(this.data.data).forEach(el => {
        if (el.targetId) {
          this.selectedData.push({id: el.targetId, name: el.name, type: el.type})
        }
      })
    }
  },
  methods: {
    itemClick (item, type) {
      let index = this.selectedData.findIndex(c => c.id === item.id)
      if (index === -1) {
        // 只能单选
        this.selectedData = []
        this.selectedData.push({id: item.id, name: item.name, type})
      } else {
        this.selectedData.splice(index, 1)
      }
    },
    nodeClick (data) {
      this.itemClick(data, data.type)
    },
    delSelected (item) {
      let index = this.selectedData.findIndex(c => c.id === item.id)
      index !== -1 && this.selectedData.splice(index, 1)
    },
    expandNode (node) {
      node.expanded = !node.expanded
    },
    saveData () {
      this.$emit('getCandidatesuperiors', this.selectedData)
    }

  },
  computed: {
    getShowCheck () {
      return item => this.selectedData.find(c => c.id === item.id)
    },
    getWidth () {
      return node => {
        let width = 165 - ((node.level - 1) * 12)
        width = width <= 13 ? 13 : width
        return `${width}px`
      }
    }
  }

}
</script>

<style lang="scss">
.candidate-superiors-doalog {
  .el-dialog--center {
    .el-dialog__body {
      padding: 12px 10px;
      & > .content {
        width: 488px;
        height: 400px;
        border: 1px solid #C2C3C4;
        border-radius: 4px;
        .select-content {
          display: flex;
          justify-content: space-between;
          align-content: center;
          width: 100%;
          height: 100%;
          padding: 12px 0;
          .left, .right {
            width: 244px;
          }
          .left {
            padding: 2px 0;
            border-right: 1px solid #C2C3C4;
            .tabs {
              height: calc(100% - 30px);
              .tab-title {
                display: flex;
                align-content: center;
                justify-content: center;
                height: 28px;
                  text-align: center;
              }
              .tab-content {
                height: calc(100% - 30px);
                width: 100%;
                position: relative;
                .nothing {
                  width: 100%;
                  height: 100%;
                  text-align: center;
                  line-height: 350px;
                  font-size: 12px;
                  position: absolute;
                  top: 0;
                  left: 0;
                  z-index: 16;
                  color: #2A2929;
                }
                .dep-content {
                  padding-top: 10px;
                  height: 100%;
                  max-width: 500px;
                  height: 100%;
                  overflow-y: auto;
                }
              }
            }
          }
          .right {
            padding: 2px 0;
            .title {
              color: #232323;
              font-size: 12px;
              text-align: center;
              height: 28px;
              line-height: 28px;
            }
            .selected-content {
              padding-top: 10px;
              overflow-y: auto;
              height: calc(100% - 30px);
              .select-item {
                height: 28px;
                line-height: 26px;
                cursor: pointer;
                .select-item-content {
                  padding: 0 14px;
                  .group-name {
                    display: inline-block;
                    width: calc(100% - 48px);
                    font-size: 12px;
                    padding-left: 18px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    vertical-align: middle;
                    color: #2A2929;
                    padding-bottom: 2px;
                  }
                  .el-icon-error {
                    color: #CBCBCB;
                    display: none;
                    &:hover {
                      color: #EE5757;
                    }
                    &:active {
                      color: #f18180;
                    }
                  }
                }
                &:hover {
                  background-color: #ECF5FB;
                  .select-item-content {
                    .el-icon-error {
                      display: inline-block;
                    }
                  }
                }
              }
            }
          }
          .el-tree {
            .el-tree-node:focus>.el-tree-node__content {
              background-color: #ECF5FB;
            }
            .el-tree-node__content {
              &:hover {
                background-color: #ECF5FB;
              }
              .custom-dep-tree {
                padding-left: 14px;
                display: flex;
                align-items: center;
                height: 100%;
                .dep-icon {
                  color: #CBCBCB;
                  margin-right: 12px;
                  display: inline-block;
                  width: 14px;
                  height: 14px;
                  font-size: 16px;
                  margin-bottom: 3px;
                }
                .node-name {
                  color: #2A2929;
                  display: inline-block;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  font-size: 12px;
                  height: 100%;
                  line-height: 26px;
                  padding-left: 16px;
                }
                .checked-name {
                  color: #54ABF1;
                }
                .el-icon-check {
                  color: #54ABF1;
                }
              }
            }
            .is-current {
              & > .el-tree-node__content {
                background-color: #ECF5FB;
              }
            }
            // 隐藏原有的展开图标
            .el-tree-node__content > .el-tree-node__expand-icon {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/runtime/candidate-superiors.vue